import { render } from "./background.vue?vue&type=template&id=2611dc75&scoped=true"
import script from "./background.vue?vue&type=script&lang=js"
export * from "./background.vue?vue&type=script&lang=js"

import "./background.vue?vue&type=style&index=0&id=2611dc75&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2611dc75"]])

export default __exports__